import type { ScheduleCategory } from '../types';

/** 日程小类选项（筛选仍按四大 category；仅展示与存储副标题） */
export const SCHEDULE_SUBTYPE_OPTIONS: Partial<
  Record<ScheduleCategory, { value: string; label: string }[]>
> = {
  daily: [
    { value: 'daily_weekly_meeting', label: '周例会' },
    { value: 'daily_training', label: '培训' },
    { value: 'daily_internal_sync', label: '内部同步' },
    { value: 'daily_other', label: '其他' },
  ],
  market: [
    { value: 'mkt_exhibition', label: '展会' },
    { value: 'mkt_event', label: '活动' },
    { value: 'mkt_public_class', label: '公开课' },
    { value: 'mkt_salon', label: '沙龙' },
    { value: 'mkt_other', label: '其他' },
  ],
  opportunity: [
    { value: 'opp_visit', label: '客户拜访' },
    { value: 'opp_demo', label: '方案/产品演示' },
    { value: 'opp_call', label: '电话/视频会议' },
    { value: 'opp_proposal', label: '方案研讨' },
    { value: 'opp_other', label: '其他' },
    // 原「客户」大类小类并入商机（历史 subtype 仍可能为 cli_*）
    { value: 'cli_visit', label: '上门拜访' },
    { value: 'cli_callback', label: '客户回访' },
    { value: 'cli_meeting', label: '接待/会谈' },
    { value: 'cli_other', label: '其他（客户类）' },
  ],
  project: [
    { value: 'proj_milestone', label: '项目阶段会议' },
    { value: 'proj_delivery_review', label: '交付评审' },
    { value: 'proj_onsite', label: '驻场/实施' },
    { value: 'proj_meeting', label: '项目例会' },
    { value: 'proj_other', label: '其他' },
  ],
};

export function getSubtypeLabel(
  category: ScheduleCategory | undefined,
  value: string | undefined,
): string | undefined {
  if (!value || !category) return undefined;
  const effective: ScheduleCategory = category === 'client' ? 'opportunity' : category;
  const list = SCHEDULE_SUBTYPE_OPTIONS[effective];
  return list?.find((o) => o.value === value)?.label;
}

/** 与后端 content 字段约定的 JSON，兼容历史纯文本 content */
const CONTENT_PAYLOAD_VERSION = 1;

export type ParsedScheduleContent = {
  body: string;
  scheduleSubtype?: string;
};

export function parseScheduleContentPayload(content: string | undefined | null): ParsedScheduleContent {
  if (content == null || String(content).trim() === '') {
    return { body: '' };
  }
  const t = String(content).trim();
  if (t.startsWith('{')) {
    try {
      const j = JSON.parse(t) as { v?: number; st?: string; body?: string };
      if (j && j.v === CONTENT_PAYLOAD_VERSION && typeof j.st === 'string') {
        return {
          scheduleSubtype: j.st,
          body: typeof j.body === 'string' ? j.body : '',
        };
      }
    } catch {
      /* 非 JSON，按正文处理 */
    }
  }
  return { body: content };
}

export function buildScheduleContentPayload(body: string, scheduleSubtype?: string): string {
  if (scheduleSubtype && String(scheduleSubtype).trim() !== '') {
    return JSON.stringify({
      v: CONTENT_PAYLOAD_VERSION,
      st: scheduleSubtype.trim(),
      body: body || '',
    });
  }
  return body || '';
}
